<template>
  <div class="uploader-box">
    <!-- <el-dialog title="上传文件"  width="800px" :close-on-click-modal="false" class="uploader-box"> -->
    <uploader
      ref="uploader"
      :options="options"
      :file-status-text="statusText"
      :auto-start="autoStart"
      class="uploader-example"
      @file-added="onFileAdded"
      @files-added="onFilesAdded"
      @file-success="onFileSuccess"
      @file-complete="onFileComplete"
      @complete="onComplete"
    >
      <uploader-unsupport></uploader-unsupport>

      <uploader-btn :attrs="attrs" id="uploaderFile">上传文件</uploader-btn>
      <!-- <uploader-drop> -->
      <!-- <uploader-btn :attrs="attrs">上传图片</uploader-btn> -->
      <uploader-btn :directory="true" id="uploaderFolder">
        上传文件夹
      </uploader-btn>
      <!-- </uploader-drop> -->
      <uploader-list
        class="transition"
        v-show="uploaderListVisible"
        :style="{ width: uploaderListWidth + 'px' }"
      >
        <div slot-scope="props">
          <div class="file-title">
            <h3>上传列表</h3>
            <div>
              <svg
                class="icon el-icon-minus"
                aria-hidden="true"
                title="最大化"
                @click="minimize"
              >
                <use
                  :xlink:href="
                    fileListVisible ? '#icon-huanyuan' : '#icon-zuixiaohua1'
                  "
                ></use>
              </svg>
              <svg
                class="icon el-icon-full-screen"
                aria-hidden="true"
                title="最大化"
                @click="fullScreen"
              >
                <use
                  :xlink:href="
                    fullScreenFlag
                      ? '#icon-zuixiaohua'
                      : '#icon-quanpingzuidahua'
                  "
                ></use>
              </svg>
              <!-- <i class="el-icon-full-screen"></i> -->
              <i class="el-icon-close" title="关闭" @click="colse"></i>
            </div>
          </div>
          <ul
            class="file-list transition"
            :style="{ height: uploaderListHeight + 'px' }"
          >
            <li v-for="file in props.fileList" :key="file.id">
              <uploader-file
                ref="files"
                :class="'file_' + file.id"
                :file="file"
                :list="true"
              ></uploader-file>
            </li>
            <div v-if="!props.fileList.length" class="no-file">
              暂无待上传文件
            </div>
          </ul>
        </div>
      </uploader-list>
    </uploader>
    <!-- </el-dialog> -->
  </div>
</template>

<script>
import {
  MergeFragmentation,
  generateFolderStructure
} from "@/api/dataManager.js";
import { getToken } from "@/utils/common";
import Config from "@/config/app";
import SparkMD5 from "spark-md5";
import Storage from "good-storage";

export default {
  data() {
    return {
      uploaderListVisible: false,
      fileListVisible: false,
      fullScreenFlag: false,
      autoStart: false, // 是否默认上传
      catalogId: null, // 当前上传的文件夹id
      options: {
        // https://github.com/simple-uploader/Uploader/tree/develop/samples/Node.js
        // target: "https://devapi.aihuz.cn/wxapi/manager/uploadFile",
        target: this.targetFun,
        // target: Config.apiUrl + "/uploader/chunk",
        testChunks: true, //是否开启服务器分片校验
        // chunkSize: 1024 * 1024 * 5, //1MB // 分片大小
        chunkSize: 1024 * 1024 * 15, //1MB // 分片大小
        // totalChunks:1,
        simultaneousUploads: 3, //并发上传数
        // fileParameterName: "file", //上传文件时文件的参数名，默认file
        maxChunkRetries: 3, //最大自动失败重试上传次数
        allowDuplicateUploads: true, // 如果说一个文件以及上传过了是否还允许再次上传。默认的话如果已经上传了，除非你移除了否则是不会再次重新上传的，所以也就是默认值为 false。
        generateUniqueIdentifier: this.generateUUid,
        query: this.uploadQuery,
        headers: {
          // 在header中添加的验证 根据实际需要
          // Authorization: getToken()
        },
        testMethod: "POST", // 在每次上传文件过程的最开始，发送的请求 用于断点续传和秒传
        uploadMethod: "POST", // 分片上传的请求方式
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: this.checkChunkUploadedByResponseFun
      },
      attrs: {
        accept: [".*"]
      },
      statusText: {
        success: "上传成功",
        error: "上传失败",
        uploading: "上传中",
        paused: "暂停中",
        waiting: "等待中"
      },
      uuids: {},
      catalogIds: {},
      sameTimeUploaderUuid: "",
      hierarchy: 0 // 记录遍历层级
    };
  },
  computed: {
    //Uploader实例
    uploader() {
      return this.$refs.uploader.uploader;
    },
    uploaderListWidth: {
      get() {
        return this.fullScreenFlag
          ? this.$store.state.app.contentViewWidth
          : 705;
      },
      set() {}
    },
    uploaderListHeight: {
      get() {
        return this.fullScreenFlag
          ? this.$store.state.app.contentViewHeight - 40
          : this.fileListVisible
          ? 0
          : 240;
      },
      set() {}
    }
  },
  mounted() {
    this.$eventBus.$on("init-uploader", nodes => {
      console.log("on-init-uploader", nodes);
      this.catalogId = nodes[0].id;
      document.getElementById(nodes[0].uploaderBtn).click();
    });
    this.$eventBus.$on("uploader-list", flag => {
      this.uploaderListVisible = flag;
    });
    //请求头添加token
    this.options.headers[this.GlobalCfg.tokenKey] = getToken();
  },
  methods: {
    targetFun(file, Chunk, event) {
      console.log(file, Chunk, event);
      if (event) {
        return Config.apiUrl + "/api/uploader/testChunk";
      } else {
        return Config.apiUrl + "/api/uploader/chunk";
      }
    },
    generateUUid() {
      return this.guid();
    },
    uploadQuery(file, Chunk) {
      console.log(file);
      console.log(Chunk);
      console.log("uploadQuery-uuids", this.uuids[file.uniqueIdentifier]);
      console.log(
        "uploadQuery-catalogIds",
        this.catalogIds[file.uniqueIdentifier]
      );
      let objFolder = {};
      if (file.isUploaderFolder) {
        objFolder["sameTimeUploaderUuid"] = file.sameTimeUploaderUuid;
        objFolder["filePath"] = file.filePath;
      }

      return {
        uuid: this.uuids[file.uniqueIdentifier],
        catalogId: this.catalogIds[file.uniqueIdentifier],
        fileType: file.fileType,
        fileExtension: file.name
          .substring(file.name.lastIndexOf(".") + 1)
          .toLowerCase(),
        md5: file.md5,
        // isUploaderFolder: file.isUploaderFolder, // true:文件夹上传 false:文件上传
        ...objFolder
      };
    },
    // 这个事件一般用作文件校验，如果说返回了 false，那么这个文件就会被忽略，不会添加到文件上传列表中。
    onFileAdded(file, event) {
      console.log(file, event);
      // let fileType = ["application/zip", "application/x-zip-compressed"];
      // if (fileType.includes(file.fileType)) {
      const flag = true; // 支持上传所有文件
      if (flag) {
        // 在这里重新生成文件唯一标识，不用插件生成的唯一标识(因为在上传多个文件的场景下，唯一标识会用同一批上传的标识，重复了)
        this.uuids[file.uniqueIdentifier] = this.guid();
        this.catalogIds[file.uniqueIdentifier] = this.catalogId;
        console.log("this.uuids", this.uuids);
        console.log("this.catalogIds", this.catalogIds);
        console.log(this.uploader);
        this.computeMD5(file);
        // this.options.chunkSize = file.size + "";
        file.ignored = false;
        this.uploaderListVisible = true;
      } else {
        // this.$message.error('只支持上传".zip" 格式');
        file.ignored = true;
      }
    },
    // 和 onFileAdded 一样，但是一般用作多个文件的校验
    onFilesAdded(files, fileList, event) {
      console.log(files, fileList, event);

      // let folderTree = [{
      //   folderName: "", // 文件夹名字
      //   children: [], // folderName文件夹下 的文件夹树
      //   filesList: [] // folderName文件夹下的文件列表
      // }];
      // 用于表示同一个文件夹下的文件
      const sameTimeUploaderUuid = this.guid();
      let paths = [];
      files.forEach(i => {
        paths.push(i.relativePath);
      });
      files.forEach(item => {
        const path = item.relativePath.split("/");
        // 判断此次是文件上传还是文件夹上传
        if (path.length === 1) {
          // 文件上传
          item["isUploaderFolder"] = false;
          // item["folderTree"] = [];
          // item["sameTimeUploaderUuid"] = "";
        } else {
          // 文件夹上传
          item["isUploaderFolder"] = true;
          item["sameTimeUploaderUuid"] = sameTimeUploaderUuid;
          item["filePath"] = paths;
          // debugger;
          // for (let index = 0; index < path.length; index++) {
          //   const pathName = path[index];
          //   let tree = array => {
          //     let ss = array.map((it) => {
          //       if (index === 0 && it.folderName === "") {
          //         // 根节点
          //         it.folderName = pathName;
          //         console.log(it);
          //       } else if (index === path.length - 1) {
          //         // 叶节点
          //         if (path[index - 1] === it.folderName && this.hierarchy === index) {
          //           this.hierarchy = 0;
          //           it.filesList.push({ fileName: pathName })
          //         } else {
          //           this.hierarchy += 1;
          //           tree(it.children);
          //         }
          //       } else {
          //         // 树节点
          //         if (it.folderName === pathName) {
          //           //  存在该文件夹，什么都不做
          //         } else if (it.folderName === path[index - 1]) {
          //           // 当children为空时直接插入
          //           if (it.children.length === 0) {
          //             it.children.push({
          //               folderName: pathName, // 文件夹名字
          //               children: [], // folderName文件夹下 的文件夹树
          //               filesList: [] // folderName文件夹下的文件列表
          //             })
          //           } else {
          //             // 否则需要判断是否存在该文件夹，存在就直接忽略，否则再插入
          //             it.children.forEach((i, inx) => {
          //               if (i.folderName !== pathName && inx === it.children.length - 1) {
          //                 it.children.push({
          //                   folderName: pathName, // 文件夹名字
          //                   children: [], // folderName文件夹下 的文件夹树
          //                   filesList: [] // folderName文件夹下的文件列表
          //                 });
          //               }
          //             });
          //           }
          //         } else {
          //           tree(it.children);
          //         }
          //       }
          //       return it;
          //     });
          //     return ss;
          //   }
          //   folderTree = tree(folderTree);
          // }
        }
      });
    },
    // 文件上传 完成
    onFileSuccess(rootFile, file, response, chunk) {
      console.log("onFileSuccess", rootFile, file, response, chunk);
      delete this.uuids[file.uniqueIdentifier];
      delete this.catalogIds[file.uniqueIdentifier];
      const filePath = {};
      if (rootFile.isFolder) {
        // 该 onFileSuccess 事件只创建一次，上传多次文件夹，会将file文件信息push到 rootFile.files，所以需要拿最后一个数组才是正确的
        const length = rootFile.files.length - 1;
        filePath["filePath"] = rootFile.files[length].filePath;
        filePath["sameTimeUploaderUuid"] =
          rootFile.files[length].sameTimeUploaderUuid;
      }
      const obj = JSON.parse(response);
      const spanNode = document.querySelector(
        `.file_${rootFile.id} > .uploader-file-info > .uploader-file-status`
      );
      if (obj.data.skipUpload) {
        // 秒传，不需要发送合并接口
        this.$eventBus.$emit("init-table-data", this.catalogId);
        spanNode.innerHTML = "秒传";
        return;
      }
      if (!obj.data.mergeFile) {
        this.$eventBus.$emit("init-table-data", this.catalogId);
        return;
      }
      // 文件过大时，后端合并分片需要一定时间，前端请求超过一定时间会出现超时无响应，就利用定时器每一秒请求一次
      let mergeFragmentation = () => {
        MergeFragmentation({
          ...obj.data,
          ...filePath
        })
          .then(res => {
            if (res.data.flag) {
              const colseTimeout = setTimeout(() => {
                mergeFragmentation();
                spanNode.innerHTML = "分片合并中";
                clearTimeout(colseTimeout);
              }, 1000);
            } else {
              spanNode.innerHTML = "合并成功";
              this.$eventBus.$emit("init-table-data", this.catalogId);
            }
          })
          .catch(() => {
            spanNode.innerHTML = "合并失败,请重新上传";
          });
      };
      mergeFragmentation();
    },
    onFileComplete(rootFile, file) {
      console.log(rootFile, file);
      if (rootFile.isFolder) {
        console.log(this.catalogId);
        this.$eventBus.$emit("init-tree", this.catalogId);
      }
    },
    computeMD5(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();

      // 文件状态设为"计算MD5"
      // this.statusSet(file.id, "md5");
      file.pause();

      loadNext();

      fileReader.onload = e => {
        spark.append(e.target.result);

        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();

          // 上传文件夹时不展示计算进度
          if (file.filePath === null) {
            // 实时展示MD5的计算进度
            this.$nextTick(() => {
              let spanNode = document.querySelector(
                `.file_${file.id} > .uploader-file-info > .uploader-file-status`
              );
              spanNode.innerHTML =
                "校验MD5 " + ((currentChunk / chunks) * 100).toFixed(0) + "%";
            });
          }
        } else {
          let md5 = spark.end();
          this.computeMD5Success(md5, file);
          console.log(
            `MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${
              file.size
            } 用时：${new Date().getTime() - time} ms`
          );
        }
      };

      fileReader.onerror = function() {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;

        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },
    computeMD5Success(md5, file) {
      // file.uniqueIdentifier = md5;
      file["md5"] = md5;
      if (file.filePath !== undefined) {
        // 文件夹上传时
        const filePathLength = file.filePath.length;
        if (Storage.get(file.sameTimeUploaderUuid) === undefined) {
          let num = 0;
          // 表示正在创建文件夹，其它分片一律等待
          Storage.set(file.sameTimeUploaderUuid, false);
          this.sameTimeUploaderUuid = file.sameTimeUploaderUuid;
          let generateFolderStructureFun = () => {
            let colseTimeout;
            generateFolderStructure({
              sameTimeUploaderUuid: file.sameTimeUploaderUuid,
              filePath: file.filePath,
              catalogId: this.catalogIds[file.uniqueIdentifier]
            }).then(res => {
              // let spanNode = document.querySelector(
              //   `.file_${file.id + 1} > .uploader-file-info > .uploader-file-status`
              // );
              if (res.data.flag === "true") {
                // spanNode.innerHTML = res.msg;
                colseTimeout = setTimeout(() => {
                  generateFolderStructureFun();
                }, (filePathLength - num) * 35);
                num = filePathLength / 2;
              } else {
                // 继续上传
                file.resume();
                // 文件夹创建完成，其它分片可以继续上传
                Storage.set(file.sameTimeUploaderUuid, true);
                clearTimeout(colseTimeout);
              }
            });
          };
          generateFolderStructureFun();
        } else {
          // 其它分片需要等generateFolderStructure接口创建完文件夹后才继续上传
          let num1 = 0;
          let resumeFun = () => {
            let colseTimeout1;
            if (Storage.get(file.sameTimeUploaderUuid)) {
              // 继续上传
              file.resume();
              clearTimeout(colseTimeout1);
            } else {
              colseTimeout1 = setTimeout(() => {
                resumeFun();
              }, (filePathLength - num1) * 35);
              num1 = filePathLength / 2;
            }
          };
          resumeFun();
        }
      } else {
        // 继续上传
        file.resume();
      }

      console.log(file);

      // this.statusRemove(file.id);
    },
    // 上传完成调用
    onComplete() {
      if (Storage.get(this.sameTimeUploaderUuid) !== undefined) {
        Storage.remove(this.sameTimeUploaderUuid);
      }
    },
    checkChunkUploadedByResponseFun(chunk, message) {
      console.log(chunk, message);
      let objMessage = JSON.parse(message);
      if (objMessage.data.skipUpload) {
        return true;
      }
      if (objMessage.data.uuid) {
        for (const key in this.uuids) this.uuids[key] = objMessage.data.uuid;
      }
      return (objMessage.data.uploaded || []).indexOf(chunk.offset + 1) >= 0;
    },
    guid() {
      return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    minimize() {
      this.fileListVisible = !this.fileListVisible;
      if (this.fileListVisible) {
        this.fullScreenFlag = false;
      }
    },
    fullScreen() {
      this.fullScreenFlag = !this.fullScreenFlag;
      if (this.fullScreenFlag) {
        this.fileListVisible = false;
      }
    },
    colse() {
      this.uploaderListVisible = false;
    }
  },
  beforeDestroy() {
    this.$eventBus.$off("init-uploader");
    this.$eventBus.$off("init-tree");
  }
};
</script>

<style lang="scss" scoped>
.uploader-box {
  position: fixed;
  z-index: 99;
  /deep/ .el-dialog {
    margin-top: 10vh !important;
  }
  .uploader-example {
    font-size: 12px;
    .tips {
      margin-top: 5px;
    }
    .uploader-btn {
      margin-right: 4px;
    }
    .uploader-list {
      // max-height: 440px;
      overflow: auto;
      overflow-x: hidden;
      overflow-y: auto;
      z-index: 99999;
    }
    ul {
      padding: unset;
      li {
        list-style: none;
      }
    }
    .no-file {
      height: 50px;
      line-height: 50px;
      text-align: center;
    }
    .uploader-list {
      position: fixed;
      width: 550px;
      background: white;
      right: 6px;
      bottom: 0;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      box-shadow: 0px 0px 15px #99999942;
      .file-title {
        display: flex;
        justify-content: space-between;
        padding: 10px;
        .el-icon-minus,
        .el-icon-full-screen,
        .el-icon-close {
          color: #0086f1;
          font-weight: bold;
          font-size: 18px;
          cursor: pointer;
          margin-left: 8px;
          vertical-align: top;
        }
      }
      .file-list {
        height: 200px;
        overflow-y: auto;
      }
    }
  }
}

.transition {
  transition: all 0.2s ease 0s;
}
</style>
